import React, { createContext, useState, useEffect } from "react";
import { useLocation  } from "react-router-dom";
import { downloadExportRequest} from '../helpers/auth'
import "../css/layout.css";

import Navbar from "./Navbar";
import Footer from "./Footer";
import AlertBanner from "./AlertBanner";

export const AlertsContext = createContext();
export const ExportContext = createContext()

let hideNavbarLocations = ["/login", "/set_new_password" , "/server_error"];

function Layout ({ content }) {
  const location = useLocation();
  const hideBars = hideNavbarLocations.includes(location.pathname); 
  const [alertBanners, setAlertBanners] = useState([]);


  function del_alert_banner(id) {
    setAlertBanners(prevAlertBanners => prevAlertBanners.filter((ab) => ab.props.id !== id));
  }

  function addAlertBanner(text, type, duration=1500) {
    let key = Date.now();
    let ab = (
      <AlertBanner
        text={text}
        type={type}
        fadeOutDuration={duration}
        id={key}
        key={key}
        cb_del={()=>{del_alert_banner(key)}}
      ></AlertBanner>
    );
    setAlertBanners(prevAlertBanners => [ab, ...prevAlertBanners ]);
  }


  function downloadExport(path, fileName, body = {}) {
    addAlertBanner("Generuji export.", "info");
    downloadExportRequest(path, body)
      .then((res) => {
        if (res.status !== 200) {
          addAlertBanner("Nepodařilo se exportovat data", "danger");
          return;
        }
        addAlertBanner("Úspěch, report se stahuje.", "success");
        const blob = new Blob(["\ufeff" + res.data], { type: 'text/csv;charset=utf-8;' });
        const aElement = document.createElement('a');
        aElement.setAttribute('download', fileName);
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
      })
      .catch((error) => {
        addAlertBanner("Došlo k chybě při stahování souboru", "danger");
        console.error("Download error:", error);
      });
  }



  return (
    <div className="layout-container">
        <div className="alert-banners-container">
          {alertBanners.map((alertBanner, index) => {
            return alertBanner;
          })}
        </div>
      {!hideBars &&  <Navbar></Navbar>}
      <AlertsContext.Provider value={addAlertBanner}>
        <ExportContext.Provider value={downloadExport}>
          <div className="main-content">{content}</div>
        </ExportContext.Provider>
      </AlertsContext.Provider>
      <Footer/>
    </div>
  );
};

export default Layout;
